import { CompareTariffRowData } from '../CompareTariffsTable/CompareTariffsTable.constants';
import CompareTariffsValue from '../CompareTariffsValue/CompareTariffsValue';

import styles from './CompareTariffsRow.module.sass';

interface CompareTariffsRowProps {
  title: string;
  lite: CompareTariffRowData;
  pro: CompareTariffRowData;
  proPlus: CompareTariffRowData;
}

const CompareTariffsRow = ({
  title,
  lite,
  pro,
  proPlus,
}: CompareTariffsRowProps) => {
  return (
    <div className={styles.row}>
      <div className={styles.title}>{title}</div>

      <div className={styles.lite}>
        <CompareTariffsValue value={lite} />
      </div>

      <div className={styles.pro}>
        <CompareTariffsValue value={pro} />
      </div>

      <div className={styles.proPlus}>
        <CompareTariffsValue value={proPlus} />
      </div>
    </div>
  );
};

export default CompareTariffsRow;
